










































































































































































































































































































import Vue from 'vue'
import { UAParser } from 'ua-parser-js'
import axios from 'axios'
import TitleName from '../atoms/TitleName.vue'
import ModalPanel from '../atoms/ModalPanel.vue'
import ReturnButton from '../atoms/ReturnButton.vue'
import SubmitFlow from '../organisms/SubmitFlow.vue'
import { TestInfo } from '../../utils/service/KoushiSite'

type ImageSrc = {
  submitScreenShot: any,
  qrScreenShot: any,
  pictureScreenShot: any,
  ngPictureThin: any,
  ngPictureAngle: any,
  ngPictureShadow: any,
}

export type DataType = {
  titleName: string
  showContent: boolean
  showSubmit: boolean
  showImage: boolean
  showImagePath: string | null
  width: number | null
  isSubmittableEnv: boolean | undefined
}
export default Vue.extend({
  components: {
    TitleName,
    ModalPanel,
    ReturnButton,
    SubmitFlow
  },
  data(): DataType {
    return {
      titleName: 'テスト提出',
      showContent: false,
      showSubmit: false,
      showImage: false,
      showImagePath: null,
      width: null,
      isSubmittableEnv: undefined,
    }
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    await this.checkSubmittable()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    "$route.hash"(newValue) {
      if(!newValue) return
      this.$nextTick(() => {
        this.scrollToSubmitFlow()
      })
    }
  },
  computed:{
    displayForMember(): boolean {
      return this.$store.state.isMemberPage
    },
    isMAGAZINE(): boolean {
      if (this.displayForMember) return true;
      return this.$store.state.examInfo.type === 'MAGAZINE'
    },
    testInfo(): TestInfo | null {
      return this.$store.state.submittingTestInfo as TestInfo
    },
    envCheckUrl() {
      if (this.displayForMember) {
        return `${process.env.VUE_APP_ROOT_PATH}/participant/device/#tensaku`
      } else {
        return `/tensaku_visiter/device/`
      }
    },
    memberPageUrl() {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/my-page`
    },
    submitTestPath(): string {
      return this.displayForMember
        ? '/tensaku/'
        : '/tensaku_visiter/'
    },
    takePicturePagePath(): string {
      return this.displayForMember
        ? '/tensaku/photograph'
        : '/tensaku_visiter/photograph'
    },
    isSubmittingShikoryoku(): boolean {
      if (this.testInfo?.name?.includes('思考力')) {
        return true
      }
      return false
    },
    variableImageSrc(): ImageSrc {
      const srcs: ImageSrc = {
        submitScreenShot: undefined,
        qrScreenShot: undefined,
        pictureScreenShot: undefined,
        ngPictureThin: undefined,
        ngPictureAngle: undefined,
        ngPictureShadow: undefined,
      }

      if (this.displayForMember) {
        srcs.submitScreenShot = require('@/assets/img/submit_member_screenshot.png')
        if (this.isSubmittingShikoryoku) {
          srcs.qrScreenShot = require('@/assets/img/qr_member_screenshot.png')
          srcs.pictureScreenShot = require('@/assets/img/picture_member_screenshot.png')
        } else {
          srcs.qrScreenShot = require('@/assets/img/qr_member_jitsuryoku_screenshot.png')
          srcs.pictureScreenShot = require('@/assets/img/picture_member_jitsuryoku_screenshot.png')
        }
      } else if (this.isMAGAZINE){
        srcs.submitScreenShot = require('@/assets/img/submit_notmember_screenshot_MAGAZINE.png')
        srcs.qrScreenShot = require('@/assets/img/qr_notmember_screenshot_MAGAZINE.png')
        srcs.pictureScreenShot = require('@/assets/img/picture_notmember_screenshot_MAGAZINE.png')
      } else {
        srcs.submitScreenShot = require('@/assets/img/submit_notmember_screenshot_WEB.png')
        srcs.qrScreenShot = require('@/assets/img/qr_notmember_screenshot_WEB.png')
        srcs.pictureScreenShot = require('@/assets/img/picture_notmember_screenshot_WEB.png')
      }

      if (this.isSubmittingShikoryoku) {
        if (this.displayForMember) {
          srcs.ngPictureThin = '/image/ng_img1_thumb.JPG'
          srcs.ngPictureAngle = '/image/ng_img2_thumb.JPG'
          srcs.ngPictureShadow = '/image/ng_img3_thumb.JPG'
        } else {
          if (this.isMAGAZINE) {
            srcs.ngPictureThin = `/image/ng_img1_${this.$store.state.examInfo.examGroupKey}_thumb.jpg`
            srcs.ngPictureAngle = `/image/ng_img2_${this.$store.state.examInfo.examGroupKey}_thumb.jpg`
            srcs.ngPictureShadow = `/image/ng_img3_${this.$store.state.examInfo.examGroupKey}_thumb.jpg`
          } else {
            srcs.ngPictureThin = `/image/ng_img1_${this.$store.state.examInfo.examGroupKey}_thumb.jpg`
            srcs.ngPictureAngle = `/image/ng_img2_${this.$store.state.examInfo.examGroupKey}_thumb.jpg`
            srcs.ngPictureShadow = `/image/ng_img3_${this.$store.state.examInfo.examGroupKey}_thumb.jpg`
          }
        }
      } else {
        srcs.ngPictureThin = '/image/ng_img1_jitsuryoku_thumb.jpg'
        srcs.ngPictureAngle = '/image/ng_img2_jitsuryoku_thumb.jpg'
        srcs.ngPictureShadow = '/image/ng_img3_jitsuryoku_thumb.jpg'
      }

      return srcs
    }
  },
  methods: {
    handleResize(): void {
      this.width = window.innerWidth;
    },
    openModal(): void {
      this.showSubmit = true
    },
    closeModal(): void {
      this.showSubmit = false
    },
    openImageModal(path: string): void {
      this.showImagePath = path
      this.showImage = true
    },
    closeImageModal(): void {
      this.showImagePath = null
      this.showImage = false
    },
    moveTakePicturePage(): void {
      // 会員の場合はgoogle analytics 対応
      if (this.testInfo && this.displayForMember) this.sendGoogleAnalytics(this.testInfo, '提出する')

      this.$router.push(this.takePicturePagePath)
    },
    getTestTypeName(info: TestInfo): string {
      let testTypeName
      if (info.name.includes('思考力')) {
        testTypeName = '小学館思考力テスト'
      } else if (info.name.includes('実力診断')) {
        testTypeName = '学年末実力診断テスト'
      } else {
        testTypeName = info.name
      }
      return testTypeName
    },
    hankaku2Zenkaku(str: string): string {
      return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
    },
    sendGoogleAnalytics(info: TestInfo, btnName: 'アドバイスシート' | '提出する'): void{
      let testName
      if (info.name.includes('思考力')) {
        testName = '思考力テスト'
      } else if (info.name.includes('実力診断')) {
        testName = '実力診断テスト'
      }
      (window as any).dataLayer.push({
        "eventCategory_click": `${testName}_${info.nendo + '年度'} ${this.hankaku2Zenkaku(info.course_name)}コース`,
        "eventAction_click": `${testName}_${info.month + '月号'} ${this.getTestTypeName(info)}`,
        "eventLabel_click": `${testName}_${btnName}`,
        "event": "click_tensaku"
      });
    },
    scrollToSubmitFlow(): void {
      const ref: any = this.$refs['submit-flow']
      ref.$el.scrollIntoView({ behavior: 'smooth' })
    },
    backToSubmitTest(): void {
      const path = this.submitTestPath

      if (path === this.$store.state.prevPath) {
        this.$router.go(-1)
      } else {
        this.$router.push(path)
      }
    },
    async checkSubmittable() {
      const userAgent = window.navigator.userAgent
      const requestHeaders = await this.getRequestHeaders()

      // const uaParser = new UAParser(userAgent)
      // await axios.post(
      //   '/api/v1/debug/dump_data',
      //   {
      //     'userAgent': userAgent,
      //     'requestHeaders': requestHeaders,
      //   }
      // )

      this.isSubmittableEnv = this.isSubmittable(userAgent, requestHeaders)
    },
    async getRequestHeaders(): Promise<any> {
      const requestHeaders = await axios.post(
        '/api/v1/debug/echoback_headers', {}
      )
      return requestHeaders.data.headers
    },
    isSubmittable(userAgent: string, requestHeaders: any): boolean {
      // 対応外ブラウザを除外する
      const allowedBrowsers = ['Chrome', 'Safari', 'Mobile Safari']
      const uaParser = new UAParser(userAgent)
      const browser = uaParser.getBrowser().name!
      if (!allowedBrowsers.includes(browser)) {
        return false
      }

      // HTTPリクエストヘッダがAndroid WebViewのような内容の場合除外する
      if (uaParser.getOS().name?.startsWith("Android") && requestHeaders['HTTP_X_REQUESTED_WITH']) {
        return false
      }

      // タッチ可能なら提出可能なモバイル端末と判定する
      if ('ontouchend' in document) {
        return true
      }
      // 画面幅が狭い場合はスマホ扱いにする
      if (this.width && this.width <= 768) {
        return true
      }
      return false
    },
  }
})
